import { action, computed, makeObservable, observable } from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import DashboardDateRangeValidity from "../DashboardDateRangeValidity";

export default class SalesByCustomerFeature extends Feature {
    constructor(application, filters) {
        super(application);
        this._filters = filters;
        this._salesByCustomer = null;

        makeObservable(this, {
            _salesByCustomer: observable,
            salesByCustomer: computed,
            setSalesByCustomer: action,
        });
    }

    async load() {
        if (!DashboardDateRangeValidity.isValid(this._filters.fromDate, this._filters.toDate)) {
            return;
        }
        await this._getSalesByCustomer();
        this.finishLoading();
    }

    setSalesByCustomer(data) {
        this._salesByCustomer = data;
    }

    get salesByCustomer() {
        return this._salesByCustomer;
    }

    async _getSalesByCustomer() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.setSalesByCustomer(response.salesByCustomer());
            },
            handlesError: () => {
                errorToast("No se pudieron obtener las ventas por cliente");
                this.setSalesByCustomer({ rows: [], total: null });
            },
        });
        return this._application.apiClient().getSalesByCustomer(responseHandler, this._filters.fromDate,
                                                                this._filters.toDate, this._filters.channels,
                                                                this._filters.articleCategories,
                                                                this._filters.withoutAllowances);
    }
}
